import ConsultaBase from "../shared/ConsultaBase";
import { fullServiceCoolingV2_1CompConsultaConfig } from "../config/fullServiceCoolingV2_1CompConsulta";

const CFSCV21Comp = () => {
  return <ConsultaBase config={fullServiceCoolingV2_1CompConsultaConfig} />;
};

export default CFSCV21Comp;